module.exports = __webpack_public_path__ + "static/media/john.f8d0df5e.png";